export default function AboutSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="w-10 h-px bg-primary-500/60 mb-6"></div>
            <p className="text-sm tracking-widest uppercase text-foreground-500 font-label">
              About the Team
            </p>
          </div>
          <div className="lg:col-span-8">
            <p className="text-lg md:text-xl text-foreground-700 leading-relaxed mb-8 font-light">
              We are a focused engineering team based in Zagreb, Croatia, dedicated
              to crafting modern digital software solutions. Our work centers on the
              iOS platform and its surrounding ecosystem, where we combine deep
              technical expertise with a genuine commitment to excellence.
            </p>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed font-light">
              Every system we build is designed to be scalable, maintainable, and
              performant. We prioritize usability and stability, ensuring that the
              software we deliver not only meets immediate needs but remains robust
              and adaptable well into the future. Long-term technical quality is at
              the heart of everything we do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}